import React from 'react';
export function Footer() {
  return <footer className="bg-[#07121f] px-4 pb-28 pt-10 text-center" data-id="element-153" data-mp="32wmqrybuniwl">
      <p className="font-serif text-lg font-bold text-gold-light" data-id="element-154" data-mp="3gfiyquovsxjx">Oral Rehabilitation Blueprint™</p>
      <p className="mt-1 text-sm text-white/70" data-id="element-155" data-mp="32ovw4rg02nik">Created by Dr. Nathan Brooks</p>
      <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-white/55" data-id="element-156" data-mp="36oxzd51dvozy">
        A practical visual planning framework for dental professionals who want to organize, document, and review complex oral
        rehabilitation cases with greater clarity. This is an educational and organizational resource and does not replace
        clinical judgment.
      </p>
      <p className="mt-6 text-xs text-white/45" data-id="element-157" data-mp="3lgop4lv2k8qa">© 2026 · Dr. Nathan Brooks · Oral Rehabilitation Blueprint™ · All rights reserved.</p>
    </footer>;
}